import React, { useState, useEffect, useMemo } from "react";
import { InvoiceReceipt } from "../../pages";
import { invoiceStore } from "../../stores";
import { InvoiceController } from "../../controllers";

const InvoiceReceiptContainer = () => {
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const business = invoiceStore.business;

  const invoiceTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&business=${business._id}`;
  }, [currentPage, limit, business]);

  const { isLoading, data, isFetching } = InvoiceController.useGetAllInvoices(
    invoiceTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    const setInvoice = async () => {
      setLoading(true);
      await Promise.all([
        InvoiceController.getAllInvoices(),
        InvoiceController.getAllInvoicesAnalysis(),
      ]);
      setLoading(false);
    };
    setInvoice();
  }, []);

  const handleViewMore = (invoice) => {
    setViewMoreModal(true);
    invoiceStore.setSelectedInvoice(invoice);
  };

  const closeModal = () => {
    setViewMoreModal(false);
  };

  return (
    <InvoiceReceipt
      handleViewMore={handleViewMore}
      viewMoreModal={viewMoreModal}
      closeModal={closeModal}
      allInvoices={invoiceStore.allInvoices}
      allInvoicesAnalysis={invoiceStore.allInvoicesAnalysis}
      loading={loading}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
      business={business}
    />
  );
};
export default InvoiceReceiptContainer;
